import { DocumentContext } from "./document-context";
import { shortTime } from "./utils";

export const footer = (ctx: DocumentContext, user: string) => {
	const exportDate = new Date();
	return {
		text: ctx.t("features/pdf-generation.footer.export", {
			user: user,
			exportDate: exportDate.toLocaleDateString(ctx.locale),
			exportTime: exportDate.toLocaleTimeString(ctx.locale, shortTime),
		}),
		style: "footer",
	};
};

export const numberedFooter = (ctx: DocumentContext, currentPage: number, pageCount: number) => {
	return {
		text: ctx.t("features/pdf-generation.footer.numbered", {
			page: String(currentPage),
			total: String(pageCount),
		}),
		style: "footer",
	};
};
